<app-layout>
  <div class="about-us">
    <div class="row">
      <div class="about-us__header">
        <p class="h1 text-white">Quem somos</p>
        <p>Saiba um pouco sobre quem é a Yes7Tickets</p>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-6 about-us__col-left">
        <p>
          A YES7 Tickets www.yestickets.net é uma plataforma completa de Gestão em Vendas de Ingressos e Controle de
          Acesso e para todos os tipos de Eventos.
        </p>

        <p>Temos uma equipe capacitada para lhe oferecer o que há de melhor.</p>
        <p>Nossas soluções simplificam a forma de administrar seu(s) evento(s) trazendo uma gestão ágil e eficaz.</p>

        <p>Unindo tecnologia de ponta, segurança e transparência.</p>

        <p>Soluções inteligentes que revolucionam a forma de Gerir, Vender e Atender seus Eventos e Clientes.</p>

        <p>
          Entre em contato através de nosso
          <strong
            >email:
            <a href="mailto:contato@yes7tickets.net">contato&#64;yes7tickets.net</a>
          </strong>
          ou através de nosso Direct no Instagram:
          <strong><a href="https://www.instagram.com/yes7tickets">&#64;yes7tickets</a></strong>
          Responderemos o mais breve possível!
        </p>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-6 about-us__col-right">
        <img
          src="./../../../assets/images/about-us/simples-yes7-ticket-logo-colorida-branca.png"
          alt="logo simples yes7tickets" />
      </div>
    </div>
  </div>
</app-layout>
